import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AntCondition from '../../utils/AntCondition';
import AntLocalization from '../../utils/AntLocalization';
import AntBadgeStore from '../../utils/AntBadgeStore';
import './index.scss';

function severityFromCount(n) {
    if (!n || n <= 0) return 'none';
    if (n < 5) return 'info';
    if (n <= 20) return 'warning';
    return 'danger';
}

export default function AntHomeQuickJumpButton(props) {
    const navigate = useNavigate();
    const [count, setCount] = useState(null);

    var visible = AntCondition.isVisible(null, props);
    var badgeApi = props.badgeApi || (props.module && props.table ? { module: props.module, table: props.table, searchConditions: props.searchConditions } : null);
    var apiKey = badgeApi ? (badgeApi.module + ':' + badgeApi.table + ':' + JSON.stringify(badgeApi.searchConditions || {})) : '';
    var hasControlledCount = props.count !== undefined && props.count !== null;
    // badgePath: khóa số đếm của badgeRegistry BE (snapshot.counts theo path, cùng nguồn với huy hiệu thực đơn).
    var badgePath = typeof props.badgePath === 'string' && props.badgePath ? props.badgePath : null;

    useEffect(() => {
        if (hasControlledCount || !visible || !badgePath) return undefined;
        AntBadgeStore.registerPaths([badgePath]);
        var unsubscribe = AntBadgeStore.subscribe(function (snapshot) {
            var n = (snapshot && snapshot.counts && snapshot.counts[badgePath]) || 0;
            setCount(n);
        });
        return function () {
            unsubscribe();
            AntBadgeStore.unregisterPaths([badgePath]);
        };
    }, [visible, badgePath, hasControlledCount]);

    useEffect(() => {
        if (hasControlledCount || badgePath) return undefined;
        if (!visible || !badgeApi || !badgeApi.module || !badgeApi.table) return undefined;
        // Khoá = 'qj:' + path: BE đếm theo entry `qj:<path>` của badgeRegistry, không nhận điều kiện từ FE.
        var key = 'qj:' + (props.path || apiKey);
        AntBadgeStore.registerItems([{
            key: key,
            module: badgeApi.module,
            table: badgeApi.table,
            searchConditions: badgeApi.searchConditions || {}
        }]);
        var unsubscribe = AntBadgeStore.subscribe(function (snapshot) {
            var n = (snapshot && snapshot.counts && snapshot.counts[key]) || 0;
            setCount(n);
        });
        return function () {
            unsubscribe();
            AntBadgeStore.unregisterItems([key]);
        };
    }, [visible, apiKey, hasControlledCount, badgePath, props.path]);

    if (!visible) return null;

    var displayCount = hasControlledCount ? props.count : count;
    var sev = props.severity || severityFromCount(displayCount);
    var showBadge = displayCount !== null && displayCount !== undefined && displayCount > 0;
    var labelText = AntLocalization.translateText(props.label || props.title);
    var variant = props.variant || 'card';

    function onClick(e) {
        if (props.onClick) return props.onClick(e);
        if (props.anchorKey && props.onAnchorClick) return props.onAnchorClick(props.anchorKey);
        if (props.path) navigate(props.path);
    }

    var className = 'ant-home-quickjump ant-home-quickjump--' + variant + ' ant-home-quickjump--' + sev;
    if (props.active) className += ' ant-home-quickjump--active';

    return (
        <button className={className} onClick={onClick} title={labelText}>
            {props.icon && <span className={'ant-home-quickjump__icon dx-icon-' + props.icon}></span>}
            <span className="ant-home-quickjump__label">{labelText}</span>
            {showBadge && <span className={'ant-home-quickjump__badge ant-home-quickjump__badge--' + sev}>{displayCount}</span>}
        </button>
    );
}
